module.exports = __webpack_public_path__ + "aa2d47eb2546474277f786c491deb100.woff2";